export default "__VITE_ASSET__DzJEdScY__"